<template>
  <div>
  <table class="table-bordered table-hover tbl datatables" style="width:100%;">
    <thead class="thead-default tablehead">
      <tr>
        <th class="text-center">Shipment ID</th>
        <th class="text-center">Picked Date</th>
        <th class="text-center">Aging</th>
        <th class="text-center">PickedBy</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item,index) in rvpInscanPendingShipments" :key="index" class="text-center">
      <td>{{item.ShippingId}}</td>
      <td>{{item.PickedDate}}</td>
      <td>{{item.Aging}}</td>
      <td>{{item.PickedBy}}</td>
    </tr>
    <tr v-if="rvpInscanPendingShipments.length==0">
      <td colspan="35" align="center">No record found</td>
    </tr>
  </tbody>
  </table><br>
  </div>
</template>


<script>
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading'

export default{
  name: "rvpInscanPending",
  components: {
    Paginate,VueElementLoading
  },
  data:function(){
  return {
    pagecount:1,
    }
  },
  props: {
    rvpInscanPendingShipments: {
      type: Array,
      required: true
    },
  },
  methods:{

  }
}
</script>


<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/views/components/common/rvpInscanPending.vue?452af10f